import {
  AUTO_ENROLLMENT_REGISTRATION_PATH,
  DBT_REFERRAL_REGISTRATION_PATH,
} from '../../../common/constants/registrationFormConstants'

export function isInRegisterFlow(pathname: string) {
  return (
    isPathInAutoEnrollmentFlow(pathname) ||
    isPathInDbtReferralFlow(pathname) ||
    [
      '/register/account-setup',
      '/register/verify-account',
      '/register/verify',
      '/register/connect',
      '/register/code',
    ].some((path) => pathname.startsWith(path))
  )
}

export function isPathInAutoEnrollmentFlow(pathname: string) {
  return pathname.startsWith(AUTO_ENROLLMENT_REGISTRATION_PATH)
}

export function isPathInDbtReferralFlow(pathname: string) {
  return pathname.startsWith(DBT_REFERRAL_REGISTRATION_PATH)
}
